<div [ngClass]="panelClass" class="edit-series-button">
  <i (click)="editSeries()" class="hide-xs" [ngClass]="icon_class">{{icon_text}}</i>

</div>
